import { render } from "./TijdelijkAanmeldenForm.vue?vue&type=template&id=ccb92c32&scoped=true"
import script from "./TijdelijkAanmeldenForm.vue?vue&type=script&lang=js"
export * from "./TijdelijkAanmeldenForm.vue?vue&type=script&lang=js"

import "./TijdelijkAanmeldenForm.vue?vue&type=style&index=0&id=ccb92c32&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb92c32"]])

export default __exports__